import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Kesimpulan = () => {
    const columns = [
        {
            name: 'Kode',
            cell: row => row['kdKesimpulan'] 
        },
        {
            name: 'Uraian',
            cell: row => row['kesimpulan'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listKesimpulan, setlistKesimpulan] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistKesimpulan = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listKesimpulan(null,null, page, size)
            setlistKesimpulan(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistKesimpulan([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistKesimpulan(0, 10)
    }, [getlistKesimpulan])

    const handleChangePage = (page) => {
        getlistKesimpulan(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listKesimpulan(null,null, page - 1, size)
        setlistKesimpulan(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Kesimpulan</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listKesimpulan}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default Kesimpulan